import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_3 = { class: "p-fluid" }
const _hoisted_4 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_UserColumn = _resolveComponent("UserColumn")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_FieldNumber = _resolveComponent("FieldNumber")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_Entries = _resolveComponent("Entries")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Entries, {
    title: _ctx.$t('users'),
    "href-prefix": "users"
  }, {
    tables: _withCtx(() => [
      _createVNode(_component_EntriesDataTable, {
        entries: _ctx.users,
        "entries-handler": _ctx.fetchUsers,
        "href-prefix": "users"
      }, {
        actions: _withCtx(({ data }) => [
          _withDirectives(_createVNode(_component_PrimeVueButton, {
            class: "p-button-rounded p-button-text p-button-secondary",
            icon: "pi pi-key",
            onClick: ($event: any) => (_ctx.getLoginURL(data))
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('copy_login_url'),
              void 0,
              { left: true }
            ]
          ])
        ]),
        columns: _withCtx(() => [
          _createVNode(_component_PrimeVueColumn, {
            field: "id",
            header: "ID",
            sortable: ""
          }),
          (_ctx.activeUser.isSuperAdmin())
            ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                key: 0,
                field: "project_id",
                header: _ctx.$t('project'),
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.project.name), 1)
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          _createVNode(_component_PrimeVueColumn, {
            field: "type",
            header: _ctx.$t('type'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.USER_TYPES_MAP[data.type].translate_key)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "email",
            header: _ctx.$t('email'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              (_openBlock(), _createBlock(_Suspense, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UserColumn, { user: data }, null, 8, ["user"])
                ]),
                fallback: _withCtx(() => [
                  _createVNode(_component_PrimeVueColumn, { height: "10px" })
                ]),
                _: 2
              }, 1024))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "status",
            header: _ctx.$t('status'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_PrimeVueTag, {
                value: _ctx.$t(_ctx.USER_STATUSES_MAP[data.status].translate_key),
                severity: _ctx.USER_STATUSES_MAP[data.status].severity
              }, null, 8, ["value", "severity"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "balance",
            header: _ctx.$t('balance'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(_ctx.$n(data.balance, 'payout')), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "manager_id",
            header: _ctx.$t('manager'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              (data.manager)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", null, _toDisplayString(data.manager.email), 1),
                    (data.manager.alias)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(data.manager.alias), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_2
                  ], 64))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "updated_at",
            header: _ctx.$t('updated_at'),
            sortable: ""
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["entries", "entries-handler"])
    ]),
    filters: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FieldNumber, {
          modelValue: _ctx.usersFilters.id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.usersFilters.id) = $event)),
          modelModifiers: { number: true },
          label: "ID"
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.activeUser.isSuperAdmin())
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_FieldDropdown, {
              modelValue: _ctx.usersFilters.project_id,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usersFilters.project_id) = $event)),
                _ctx.onProjectChange
              ],
              modelModifiers: { number: true },
              label: _ctx.$t('project'),
              loading: _ctx.projectsLoading,
              "show-clear": true,
              options: _ctx.projects.data,
              "option-value": "id",
              "option-label": "name",
              "option-label-translate": false
            }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_FieldDropdown, {
          modelValue: _ctx.usersFilters.type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usersFilters.type) = $event)),
          modelModifiers: { number: true },
          label: _ctx.$t('type'),
          "show-clear": true,
          options: _ctx.USER_TYPES
        }, null, 8, ["modelValue", "label", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FieldDropdown, {
          modelValue: _ctx.usersFilters.role,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usersFilters.role) = $event)),
          modelModifiers: { number: true },
          label: _ctx.$t('role'),
          "show-clear": true,
          options: _ctx.USER_ROLES
        }, null, 8, ["modelValue", "label", "options"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_FieldText, {
          modelValue: _ctx.usersFilters.email,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.usersFilters.email) = $event)),
          modelModifiers: { trim: true },
          label: _ctx.$t('email')
        }, null, 8, ["modelValue", "label"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_FieldText, {
          modelValue: _ctx.usersFilters.alias,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.usersFilters.alias) = $event)),
          modelModifiers: { trim: true },
          label: _ctx.$t('alias')
        }, null, 8, ["modelValue", "label"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_FieldDropdown, {
          modelValue: _ctx.usersFilters.status,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.usersFilters.status) = $event)),
          modelModifiers: { number: true },
          label: _ctx.$t('status'),
          "show-clear": true,
          options: _ctx.USER_STATUSES
        }, null, 8, ["modelValue", "label", "options"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_FieldDropdown, {
          modelValue: _ctx.usersFilters.manager_id,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usersFilters.manager_id) = $event)),
          modelModifiers: { number: true },
          label: _ctx.$t('manager'),
          loading: _ctx.managersLoading,
          "show-clear": true,
          options: _ctx.managers.data,
          "option-value": "id",
          "option-label": "email",
          "option-label-translate": false
        }, null, 8, ["modelValue", "label", "loading", "options"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}